import * as THREE from "three";

// One sun, obeyed by everything that is lit.
//
// Before this there were three: the ground shader lit from the upper right,
// the composite drew the disc at the upper left, sprites were shaded by a
// top-down gradient with no direction at all, and shadows sat directly under
// their objects. Nothing agreed with anything, and that disagreement is most
// of what makes a billboard read as pasted on. Every consumer now derives
// from SUN_DIR; change it here and the ground, the sprites, their rims, the
// shadows and the disc all move together.
//
// World space: +x is screen right, +y is down the hill (lower on the
// screen), +z is toward the viewer. The light arrives FROM this direction.
// The elevation is the ground shader's original; the azimuth is flipped to
// the side the disc has always been drawn on, because the disc is the one
// thing about the sun a player actually sees.
export const SUN_DIR = new THREE.Vector3(-0.38, -0.22, 0.9).normalize();

// Where the composite draws the disc, in its 0..1 uv with y up. x follows the
// azimuth. y is the art's: a low sun at the top of frame is a convention of
// the top-down view, not a projection of anything -- a camera looking
// straight down cannot see the sun at all.
export const SUN_SCREEN = new THREE.Vector2(0.5 + SUN_DIR.x * 0.37, 0.96);

// The direction a shadow falls on screen, in the view's y-up coordinates:
// away from the sun, with world y flipped because the hill runs down the
// screen.
export const SHADOW_DIR = new THREE.Vector2(-SUN_DIR.x, SUN_DIR.y).normalize();
